import React from "react";
import {
  UilTemperature,
  UilTear,
  UilWind,
  UilSun,
  UilSunset,
} from "@iconscout/react-unicons";
import { formatToLocalTime } from "../services/weatherService";

function TImeAndLocation({
  weather: {
    dt,
    timezone,
    name,
    country,
    temp_min,
    temp_max,
    feels_like,
    humidity,
    speed,
  },
}) {
  return (
    <div>
      <div className="flex items-center justify-center my-6">
        <p className="text-black text-xl font-straight">
          {formatToLocalTime(dt, timezone)}
        </p>
      </div>

      <div className="flex flex-col items-center justify-center my-5">
        <div className="my-3">
          <p className="text-black text-3xl font-medium">{`${name}, ${country}`}</p>
        </div>

        <div className="flex flex-col">
          <div>
            <p className="flex flex-1 mt-5">
              <UilTear />
              Humidity:
              <span className="font-medium ml-1">{`${humidity.toFixed()}%`}</span>
              <span>|</span>
              <UilWind />
              Wind:
              <span className="font-medium ml-1">{`${speed.toFixed()} km/h`}</span>
            </p>
          </div>

          <div>
            <p className=" flex flex-1 font-light mt-5">
              <UilTemperature />
              Low:{" "}
              <span className="font-medium ml-1">{`${temp_min.toFixed()}°`}</span>
              <p> | </p>
              <UilTemperature />
              High:{" "}
              <span className="font-medium ml-1">{`${temp_max.toFixed()}°`}</span>
              <span> | </span>
              <UilTemperature size={18} className="mr-1" />
              Real fell:{" "}
              <span className="font-medium ml-1">{`${feels_like.toFixed()}°`}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TImeAndLocation;
